import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  countryCode: import.meta.env.VITE_COUNTRIES || localStorage.getItem('countryCode') || '', // Env variable takes priority over cached value
}

const countryCodeSlice = createSlice({
  name: 'countryCode',
  initialState,
  reducers: {
    setCountryCode(state, action) {
      state.countryCode = action.payload
      localStorage.setItem('countryCode', state.countryCode) // Save countryCode to localStorage
    },
  },
})

export const {setCountryCode} = countryCodeSlice.actions

export const selectCountryCode = state => state.countryCode?.countryCode // Selector for countryCode

export default countryCodeSlice.reducer
